export default __webpack_public_path__ + "static/media/blog-listing.24d3f4ae.png";